// Calculates the visible days for the calendar view.
// Phone (xs,s) = 1 day, Tablet (m,l) = 2 days, Desktop (xl) = 3 days
import { useMemo } from 'react';
import { startOfDay, format } from 'date-fns';
import {
  useBreakpoint,
  isPhoneBreakpoint,
  isTabletBreakpoint,
  isDesktopBreakpoint,
} from '@/hooks/ui/useBreakpoint.js';
import { translate as t } from '@/i18n/useT';
import {
  getDateFnsLocale,
  getShortWeekdayPattern,
} from '@/i18n/getDateFnsLocale';

const DAY_PREFIX_KEYS = [
  ['todayviewcontent.today', 'Vandaag'],
  ['taskitemswipeable.snoozeTomorrow', 'Morgen'],
  ['dates.dayAfterTomorrow', 'Overmorgen'],
];

const useCalendarDays = () => {
  const currentBreakpoint = useBreakpoint();

  const days = useMemo(() => {
    let dayCount = 3;
    if (isPhoneBreakpoint(currentBreakpoint)) {
      dayCount = 1;
    } else if (isTabletBreakpoint(currentBreakpoint)) {
      dayCount = 2;
    } else if (isDesktopBreakpoint(currentBreakpoint)) {
      dayCount = 3;
    }

    const today = new Date();
    const locale = getDateFnsLocale();
    const weekdayPattern = getShortWeekdayPattern();
    const result = [];
    for (let i = 0; i < dayCount; i += 1) {
      const d = new Date(today);
      d.setDate(d.getDate() + i);
      const start = startOfDay(d);
      const [key, fallback] = DAY_PREFIX_KEYS[i];
      const labelPrefix = t(key, fallback);
      const dayPart = format(start, `${weekdayPattern} d`, { locale });
      result.push({
        label: `${labelPrefix} (${dayPart})`,
        date: start,
      });
    }

    return result;
  }, [currentBreakpoint]);

  return days;
};

export default useCalendarDays;
